import React from 'react';

import SearchResultCard from 'components/search/search-result-card';

export class SearchPageSkeleton extends React.Component {

    getSearchCardSkeleton() {
        const placeholderArray = [];
        const placeholderCount = 10;
        const searchResultCardProps = {
            result: {
                metadata: {
                    channelInfo: {
                        channelKey: '',
                        channelTitle: '',
                    },
                    title: ''
                },
            },
            t: () => {},
            isFetching: 1
        };
        for (let i = 0; i < placeholderCount; i++) {
            placeholderArray.push(<SearchResultCard {...searchResultCardProps} />);
        }
        return placeholderArray;
    }

    render() {
        return (
            <div className="search-page-skeleton">
              {this.getSearchCardSkeleton()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/search/search-page-skeleton.js